import React from 'react'
import { RadioGroup } from 'informed'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import Divider from 'components/Divider'
import { Radio } from 'components/forms'

export default () => {
	const [t] = useTranslation()

	return (
		<>
			<Divider visible height={40} />
			<Row>
				<Col xs>
					<RadioGroup field='isForShop'>
						<Radio label={t('message_section.strings.all_messages')}/>
						<Radio value={true} label={t('message_section.strings.cashregister_messages')} />
						<Radio value={false} label={t('message_section.strings.users_messages')} />
					</RadioGroup>
				</Col>
			</Row>
			<Divider/>
		</>
	)
}
